export const namespaced = true;

export const state = {
  surveyAnswers: {},
  surveyAnswerCount: 0,
};

export const mutations = {
  ADD_ANSWER(state, data) {
    state.surveyAnswers[data.order] = {
      answer: data.answer,
      value: data.value,
      factor: data.factor,
    };
    state.surveyAnswerCount = Object.keys(state.surveyAnswers).length;
  },
  START_SURVEY(state) {
    state.surveyAnswers = {};
  },
};

export const actions = {
  addAnswer({ commit }, answer) {
    commit("ADD_ANSWER", answer);
  },
  startSurvey({ commit }) {
    commit("START_SURVEY");
  },
};
